import { Entity, IEntity } from '@lycoris-nubila/ngx-lycoris';

export interface IUserEmailModel extends IEntity {
	readonly name: string;
	readonly body: string;
	readonly userId: string;
	readonly subject: string;
}

export class UserEmailModel extends Entity implements IUserEmailModel {
	private _name: string;
	private _body: string;
	private _userId: string;
	private _subject: string;

	constructor(
		id: string,
		name: string,
		body: string,
		userId: string,
		subject: string
	) {
		super(id);
		this._name = name;
		this._body = body;
		this._userId = userId;
		this._subject = subject;
	}

	public get name(): string {
		return this._name;
	}

	public get body(): string {
		return this._body;
	}

	public get userId(): string {
		return this._userId;
	}

	public get subject(): string {
		return this._subject;
	}
}
